var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content.text)?_c('div',{class:_vm.$style['text-message']},[_vm._v(" "+_vm._s(_vm.content.text)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }